import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=6f2dff88&"
import script from "./SectionCard.vue?vue&type=script&lang=js&"
export * from "./SectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2dff88')) {
      api.createRecord('6f2dff88', component.options)
    } else {
      api.reload('6f2dff88', component.options)
    }
    module.hot.accept("./SectionCard.vue?vue&type=template&id=6f2dff88&", function () {
      api.rerender('6f2dff88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/section-card/SectionCard.vue"
export default component.exports